import {Product, ProductConfiguration, ProductConfigurationType} from './product.model';
import {Document} from './document.model';
import {DictionaryItem} from './dictionary.model';
import {Partner} from './partner.model';

export class ProductPg extends Product {
    configurationType: ProductConfigurationType;
    configuration: PgProductConfiguration;
    owuFile: Document;
    isClaimStudioPolicy: boolean;
}

export class PgProductConfiguration extends ProductConfiguration {
    partnerList: Partner[];
    basicData: PgProductBasic;
}

export class PgProductBasic {
    dbn: boolean;
    dbnDescription: string;
    dbnValue: number;
    dkr: boolean;
    dkrMode: DictionaryItem;
    dkrPeriodString: string;
    dpg: boolean;
    dpgMode: DictionaryItem;
    dpgPeriodString: string;
    insurancePeriodString: string;
    leasing: boolean;
    limitedBrandList: boolean;
    limitedModelList: boolean;
    maxSumInsured: number;
    minSumInsured: number;
    outlet: boolean;
    paymentInstallment: boolean;
    paymentOnce: boolean;
    premiumMinInstallments: number;
    remoteSales: boolean;
    rks: boolean;
    salesDateEnd: string;
    salesDateStart: string;
    salesType: DictionaryItem;
    segment: string;
    warrantyString: string;
}
